module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Chair#2-bac11fcaf2731af80db5a69f5fd4473977479b970495db3406ce56f98eb65bc2.svg";